module.exports = __webpack_public_path__ + "img/repeated-drug-tips.8711aa41.svg";